(function () {
  const PDPcanvas = document.getElementById("product-canvas");
  const PDPctx = PDPcanvas ? PDPcanvas.getContext("2d") : null;
  const imageContainer0 = document.querySelector(".product-container");
  const scrollTriggerElement = document.querySelector(".scroll-content");

  let frameCount = 0;
  let images = [];

  /** Utility: Preload Images */
  function preloadImages(urls, callback) {
    const loaded = [];
    let count = 0;
    urls.forEach((url, i) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        count++;
        if (count === urls.length) {
          callback(loaded);
        }
      };
      loaded[i] = img;
    });
  }

  /** Utility: Draw Image to Canvas with Aspect Ratio */
  function drawImageToCanvas(img) {
    if (!img || !PDPctx || !PDPcanvas) return;

    const imgRatio = img.width / img.height;
    const canvasRatio = PDPcanvas.width / PDPcanvas.height;

    let drawWidth, drawHeight;
    if (imgRatio > canvasRatio) {
      drawWidth = PDPcanvas.width;
      drawHeight = drawWidth / imgRatio;
    } else {
      drawHeight = PDPcanvas.height;
      drawWidth = drawHeight * imgRatio;
    }

    const x = (PDPcanvas.width - drawWidth) / 2;
    const y = (PDPcanvas.height - drawHeight) / 2;

    PDPctx.clearRect(0, 0, PDPcanvas.width, PDPcanvas.height);
    PDPctx.drawImage(img, x, y, drawWidth, drawHeight);
  }

  /** Draw Frame from Index */
  function drawFrame(index) {
    const img = images[index];
    if (img?.complete) {
      drawImageToCanvas(img);
    } else {
      console.warn(`Frame ${index} not loaded yet.`);
    }
  }

  /** Setup GSAP ScrollTrigger */
  function initializeScrollTrigger() {
    if (window.innerWidth <= 768) return;

    const scene = { frame: 0 };
    const existing = ScrollTrigger.getById("productScroll");
    if (existing) existing.kill();

    gsap.registerPlugin(ScrollTrigger);

    if (window.theme.is_rtd_template) {
      // Benefit animations
      gsap.utils.toArray(".benefits-items .benefit-details").forEach((item) => {
        gsap.fromTo(
          item,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: item,
              start: "top 85%",
              toggleActions: "play none none none",
            },
          }
        );
      });

      gsap.timeline({
        id: "productScroll",
        scrollTrigger: {
          trigger: scrollTriggerElement,
          // start: "top-=250px top",
          // end: "bottom+=1000px bottom",
          start: "top top",
          end: "bottom bottom",
          scrub: 1,
        },
      }).to(scene, {
        frame: frameCount - 1,
        ease: "none",
        snap: "frame",
        onUpdate: () => {
          const frameIndex = Math.max(0, Math.floor(scene.frame));
          drawFrame(frameIndex);
        },
      });

      // Box image scroll logic
      const imgEl = document.querySelector(".box-wrapper img");
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger:
            "body.product-rtd-pdp .product.grid>.product-benefits-wrapper .benefits-items:last-child",
          start: "top 100%",
          end: "top 50%",
          scrub: true,
          onEnterBack: () => {
            if (imgEl) imgEl.src = window.theme.rtd_open_box_image;
          },
        },
      });

      const rightValue =
        window.innerWidth <= 1536 && window.innerWidth > 768 ? "52%" : "50%";

      timeline.to(".close-box-img", { right: rightValue, ease: "none" });
      timeline.add(() => {
        if (imgEl) imgEl.src = window.theme.rtd_close_box_image;
      });
    } else {
      setTimeout(() => {
        gsap.timeline({
          id: "productScroll",
          scrollTrigger: {
            trigger: scrollTriggerElement,
            start: "top top",
            end: "bottom+=250px bottom",
            scrub: 1,
          },
        }).to(scene, {
          frame: frameCount - 1,
          ease: "none",
          snap: "frame",
          onUpdate: () => {
            drawFrame(Math.max(0, Math.floor(scene.frame)));
          },
        });
      }, 350);
    }
  }

  /** Handle Mobile Swipe */
  function initializeMobileSwipe(imageUrls) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile || imageUrls.length === 0) return;

    const rotatingImage = document.querySelector("img.product-featured_image");
    rotatingImage.src = imageUrls[0];

    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
    let accumulatedDeltaX = 0;
    const pixelsPerFrame = 12;

    // Gesture hint
    function showDragGesture() {
      let frame = 0;
      const maxFrames = 15;

      const forward = setInterval(() => {
        if (frame < maxFrames) {
          rotatingImage.src = imageUrls[++frame];
        } else {
          clearInterval(forward);
          reverseGesture(frame);
        }
      }, 50);
    }

    function reverseGesture(start) {
      let frame = start;
      const reverse = setInterval(() => {
        if (frame >= 0) {
          rotatingImage.src = imageUrls[frame--];
        } else {
          clearInterval(reverse);
          rotatingImage.src = imageUrls[0];
        }
      }, 50);
    }

    setTimeout(showDragGesture, 250);

    // Swipe handling
    function handleSwipe(pageX) {
      const deltaX = pageX - startX;
      accumulatedDeltaX += deltaX;
      startX = pageX;

      const frameChange = Math.floor(accumulatedDeltaX / pixelsPerFrame);
      if (frameChange !== 0) {
        accumulatedDeltaX = 0;
        currentFrame = (currentFrame - frameChange + imageUrls.length) % imageUrls.length;
        rotatingImage.src = imageUrls[currentFrame];
      }
    }

    rotatingImage.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      accumulatedDeltaX = 0;
    });

    rotatingImage.addEventListener("touchmove", (e) => {
      if (isDragging) handleSwipe(e.touches[0].pageX);
    });

    rotatingImage.addEventListener("touchend", () => {
      isDragging = false;
    });
  }

  /** Setup Frames for Selected Variant */
  function setVariantFrames(variantId = null) {
    const selected = variantFrames.find(
      (v) => v.selected || v.variant === variantId
    );

    if (!selected) return console.warn("No valid variant found.");

    window.theme.product_animation_frames = selected.frames;
    frameCount = selected.frames.length;

    preloadImages(selected.frames, (loaded) => {
      images = loaded;
      drawFrame(0);
      initializeScrollTrigger();
      imageContainer0.classList.add("animated-ready");
      document.body.classList.add("js-canvas-animation-ready");
      initializeMobileSwipe(selected.frames);
    });

    const rotatingImage = document.querySelector("img.product-featured_image");
    if (rotatingImage && selected.frames.length > 0) {
      rotatingImage.src = selected.frames[0];
    }
  }

  /** Variant Change Handler */
  function onVariantChangeCustom(event) {
    const variantId = event.detail?.id;
    const variantData = variantFrames.find((v) => v.variant === variantId);
    const imageContainer = document.querySelector(".product-container");
    const rotatingImage = document.querySelector("img.product-featured_image");

    if (!variantData || !rotatingImage) return;

    // ✅ STOP OLD MOBILE GESTURE
    if (window.mobileGestureInterval) {
      clearInterval(window.mobileGestureInterval);
      window.mobileGestureInterval = null;
    }

    // ✅ HIDE canvas + image during transition
    PDPcanvas.style.visibility = "hidden";
    rotatingImage.style.visibility = "hidden";
    document.body.classList.add("canvas-loading");
    imageContainer.classList.remove("animated-ready");
    document.body.classList.remove("js-canvas-animation-ready");

    // ✅ Update global state
    window.theme.product_animation_frames = variantData.frames;
    frameCount = variantData.frames.length;

    // ✅ Preload all frames
    preloadImages(variantData.frames, (loaded) => {
      images = loaded;
      const firstImage = loaded[0];

      // ✅ Wait for first image to load
      const finalize = () => {
        // ✅ Draw to canvas
        drawImageToCanvas(firstImage);
        drawFrame(0);

        // ✅ Set mobile image
        rotatingImage.src = variantData.frames[0];

        // ✅ Show image + canvas
        PDPcanvas.style.visibility = "visible";
        rotatingImage.style.visibility = "visible";

        // ✅ Run gesture only if enough frames
        if (variantData.frames.length >= 10 && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          initializeMobileSwipe(variantData.frames);
        }

        // ✅ Re-init ScrollTrigger on desktop
        if (window.innerWidth > 768) {
          initializeScrollTrigger();
        }

        // ✅ Final UI cleanup
        document.body.classList.remove("canvas-loading");
        imageContainer.classList.add("animated-ready");
        document.body.classList.add("js-canvas-animation-ready");
      };

      if (!firstImage.complete) {
        firstImage.onload = finalize;
      } else {
        finalize();
      }
    });
  }

  /** Init on Load */
  if (PDPcanvas) {
    setVariantFrames(); // Initial call
  }

  document.addEventListener("myCustomEvent", onVariantChangeCustom);
})();
